<template>
    <el-dialog
        title="Invite User to Project"
        :visible.sync="dialogVisible"
        width="40%">
        <div class="form-group">
            <label>User</label>
            <user-dropdown :invited-user="invitedUser"/>
        </div>
        <div class="form-group">
            <label>Access Level</label>
            <vue-select :options="accessLevels" v-model="invitedUser.access" :reduce="access => access.value"/>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">Cancel</el-button>
            <el-button type="primary" @click="sendInvite">Send Invite</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import UserDropdown from "../../components/user/user-dropdown";
    import VueSelect from "vue-select";
    import {mapGetters} from 'vuex';

    export default {
        name: "InviteUserToProject",
        props: {
            projectId: {
                type: String,
            }
        },
        data() {
            return {
                accessLevels: [
                    {
                        value: 'owner',
                        label: 'Owner',
                    },
                    {
                        value: 'admin',
                        label: 'Admin',
                    },
                    {
                        value: 'developer',
                        label: 'Developer',
                    },
                ],
                invitedUser: {
                    userId: '',
                    access: '',
                }
            }
        },
        computed: {
            ...mapGetters({
                dialogVisible: 'getInvitedUserDialogVisible',
                users: 'getUsers',
            })
        },
        methods: {
            closeDialog() {
                this.$store.commit('setUsers', []);
                this.$store.commit('setInvitedUserDialogVisible', false);
                this.invitedUser = {
                    userId: '',
                    access: '',
                };
            },
            sendInvite() {
                axios.post(`projects/${this.projectId}/members/invite`, this.invitedUser).then(res => {
                    this.$store.dispatch('getProjects', {
                        page: 1,
                        query: ''
                    });
                    let user = this.users.filter(u => u.id === this.invitedUser.userId)[0];
                    this.$notify({
                        title: 'Invitation Sent',
                        type: 'success',
                        message: `${user.name} has been invited to be a member of the project with access [${this.invitedUser.access.toUpperCase()}] `
                    });
                    this.closeDialog();
                })
            }
        },
        components: {
            'user-dropdown': UserDropdown,
            VueSelect,
        },
    }
</script>

<style scoped>

</style>
